import * as Yup from 'yup';

export const validationSchema = () => Yup.object({
  "collPhysician": Yup
    .string()
    .nullable()
    .required("Collaborating physician is required")
});
